import request from '@/utils/request'
import qs from 'qs'
export function chainUploadStatus(data) {
  return request({
    url: `/api/chain/chainUploadStatus?`,
    method: 'post',
    data
  })
}

export function chainThirdChainServerStatus() {
  return request({
    url: `/api/chain/thirdChainServerStatus`,
    method: 'get',
  })
}

export function querySensorInfo(deviceId) {
  return request({
    url: `/api/water/querySensorInfo`,
    method: 'get',
    params: {
      deviceId
    }
  })
}

export function doWaterTask() {
  return request({
    url: '/task/doWaterTask',
    method: 'get',
    timeout: 60000,
  })
}



